export default "__VITE_ASSET__CL57lmu___"